import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LookupService } from '../services/lookup.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ManagementService } from '../services/management.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-safety-details',
  templateUrl: './safety-details.component.html',
  styleUrl: './safety-details.component.css'
})
export class SafetyDetailsComponent {
  rowDataSafety: any;
  appParentId: any = '';
  fiscalYearId: any = '';
  employeeId: any = '';
  supplierCode: any = '';
  safetyForm: FormGroup;
  domLayout='autoHeight';
  role = sessionStorage.getItem('role');
  columnDefSafety = [{
    headerName: 'Supplier Code',
    field: 'suppliercode',
    flex: 1,
  },
  {
    headerName: 'Target',
    field: 'target',
    flex: 1,
  },
  {
    headerName: 'Risk Rating',
    field: 'risk_rating',
    editable: true, 
    cellEditor: 'InputEditorComponent',
    flex: 1,
  },
  {
    headerName: 'Comment',
    field: 'comment',
    flex: 1
  }]

  constructor(
    private readonly ngxSpinner: NgxSpinnerService,
    private readonly lookup: LookupService,
    private readonly formBuilder:FormBuilder,
    private readonly management:ManagementService,
    private readonly router: Router,
    private readonly location: Location
  ){}

  ngOnInit(){
    this.ngxSpinner.show();
    this.employeeId = sessionStorage.getItem("loginAssumeEmployeeid");
    this.appParentId = sessionStorage.getItem("appParentId");
    this.fiscalYearId = localStorage.getItem("fiscalId");
    this.supplierCode = sessionStorage.getItem("suppliercode");
    this.safetyForm = this.formBuilder.group({
     target: new FormControl(''),
     riskRating: new FormControl(''),
     comment: new FormControl('')
    })
    this.getSafetyRankingDetails();
    setTimeout(() => {
      this.ngxSpinner.hide();
    }, 2000)
  }

  isOpen2 = true;
  breadcrumbItems=[
    {
      label: 'Home',
      link: '/home',
      icon: '>'
    },
    {
      label: `Safety Risk Ranking - ${sessionStorage.getItem("suppliercode")}`,
      link: null,
      icon: ''
    },
  ];

  defaultColDef={ 
    suppressNavigable: true,
    cellClass: 'no-border',
    suppressMovable: true,
    sortable: false,
    unSortIcon: true,
    wrapText: true,
    autoHeight: true,
    resizable: true,
    suppressHeaderMenuButton: true,
    suppressFloatingFilterButton: true,
  };

  getSafetyRankingDetails(){
    this.lookup.getSftyRiskCommodity(this.appParentId,this.fiscalYearId,this.employeeId).subscribe((data)=>{
      this.rowDataSafety = data.body.safetyRisk.find((safteyData) => safteyData.suppliercode == this.supplierCode);
      this.safetyForm.controls['target'].setValue(this.rowDataSafety.target);
      this.safetyForm.controls['riskRating'].setValue(this.rowDataSafety.risk_rating);
      this.safetyForm.controls['comment'].setValue(this.rowDataSafety.comment);
    });
  }

  saveSafetyRanking() {
    this.ngxSpinner.show();
    const safetyRating = this.safetyForm.controls['riskRating'].value;
    const safetyRiskRankingyBody = {
      "appParentId": this.appParentId,
      "fiscalYearId": this.fiscalYearId,
      "supplierCode": this.supplierCode,
      "riskRating": safetyRating? safetyRating: null,
      "comment": this.safetyForm.controls['comment'].value
    }
    this.management.safetyRiskRanking(safetyRiskRankingyBody).subscribe(_data=>{
      this.router.navigate(['/home']);
    })
  }

  cancelCommodity(){
    this.ngxSpinner.show();
    this.location.back();
  }
}
